import { useEffect } from "react";
import BlazeSlider from "blaze-slider";
import "blaze-slider/dist/blaze.css";

const slides = [
  {
    id: 1,
    title: "Hassle-free transport",
    description:
      "We strive to make the transportation process as smooth and stress-free as possible, whether you're a business owner trying to get your products to customers, or a person needing to move from one place to another. With our platform, you can book, track, and manage your transportation with ease, knowing that you have a reliable partner to handle the logistics for you. Experience hassle-free transport with ZAP today.",
  },
  {
    id: 2,
    title: "Regular Delivery",
    description:
      "Lorem ipsum dolor sit amet consectetur. In viverra cursus molestie sem. Pellentesque eget lorem felis pellentesque dolor sit sem. Adipiscing in volutpat ipsum tincidunt vitae.",
  },
];

function Slider() {
  useEffect(() => {
    const element: HTMLElement = document.querySelector(".blaze-slider")!;
    new BlazeSlider(element, {
      all: {
        enableAutoplay: true,
        autoplayInterval: 8000,
        transitionDuration: 1000,
        slidesToShow: 1,
      },
      "(max-width: 500px)": {
        slidesToShow: 1,
      },
    });
  }, []);

  return (
    <div className="max-lg:px-6">
      <div className="w-full lg:max-w-[700px] lg:max-h-[700px] mx-auto py-16 group">
        <div className="blaze-slider">
          <div className="blaze-container">
            <div className="blaze-track-container">
              <div className="blaze-track">
                <div className={"bg-secondary p-6 lg:p-12 rounded-lg mb-7"}>
                  <h1 className="font-semibold text-white text-2xl tracking-wide py-4">
                    {slides[0].title}
                  </h1>
                  <span className="text-border">{slides[0].description}</span>
                </div>
                <div className="bg-primary p-6 lg:p-12 rounded-lg mb-7">
                  <h1 className="font-semibold text-white text-2xl tracking-wide py-4">
                    {slides[1].title}
                  </h1>
                  <span className="text-border">{slides[1].description}</span>
                </div>
              </div>
              <div className="my-structure flex items-center justify-between">
                <button
                  className="blaze-prev py-2 px-3 rounded-full"
                  aria-label="Go to previous slide"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="w-6 h-6"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M15.75 19.5L8.25 12l7.5-7.5"
                    />
                  </svg>
                </button>
                <button
                  className="blaze-next text-black py-2 px-3 rounded-full"
                  aria-label="Go to next slide"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="w-6 h-6 text-white"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M8.25 4.5l7.5 7.5-7.5 7.5"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Slider;
